import { ActionTypes } from './constants';
import { AnalyticsTypes } from '../../middleware/google-analytics';
import * as TrackingConstants from '../../EventTrackingConstants';

export const trackAdView = () => ({
    type: ActionTypes.TRACK_AD_VIEW,
    meta: {
        analytics: {
            category: 'Telehealth',
            type: AnalyticsTypes.TrackEvent,
            action: 'View Result',
            data: {
                Component: TrackingConstants.TARGETS.TELEHEALTH_RESULT,
                Element: TrackingConstants.TARGETS.TELEHEALTH_RESULT,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.VIEW,
                Section: TrackingConstants.TARGETS.SEARCH_RESULTS,
            },
        },
    },
});

export const trackAdClick = () => ({
    type: ActionTypes.TRACK_AD_CLICK,
    meta: {
        analytics: {
            category: 'Telehealth',
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Result',
            data: {
                Component: TrackingConstants.TARGETS.TELEHEALTH_RESULT,
                Element: TrackingConstants.TARGETS.TELEHEALTH_RESULT,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Section: TrackingConstants.TARGETS.SEARCH_RESULTS,
            },
        },
    },
});

const trackDownloadClick = ({ Component, Element, Section }) => () => ({
    type: ActionTypes.TRACK_DOWNLOAD_BUTTON_CLICK,
    meta: {
        analytics: {
            category: 'Telehealth',
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Download App',
            data: {
                Component,
                Element,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Section,
            },
        },
    },
});

export const trackModalDownloadClick = trackDownloadClick({
    Component: TrackingConstants.TARGETS.TELEHEALTH_MODAL,
    Element: TrackingConstants.TARGETS.TELEHEALTH_DOWNLOAD_BUTTON,
    Section: TrackingConstants.TARGETS.SEARCH_RESULTS,
});

export const trackProfileDownloadClick = trackDownloadClick({
    Component: TrackingConstants.TARGETS.TELEHEALTH_DOWNLOAD_FOOTER,
    Element: TrackingConstants.TARGETS.TELEHEALTH_DOWNLOAD_BUTTON,
    Section: TrackingConstants.TARGETS.TELEHEALTH_PROFILE,
});

const trackSendSmsClick = ({ Component, Element, Section }) => () => ({
    type: ActionTypes.TRACK_SEND_SMS_BUTTON_CLICK,
    meta: {
        analytics: {
            category: 'Telehealth',
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Send Sms',
            data: {
                Component,
                Element,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Section,
            },
        },
    },
});

export const trackModalSendSmsClick = trackSendSmsClick({
    Component: TrackingConstants.TARGETS.TELEHEALTH_MODAL,
    Element: TrackingConstants.TARGETS.TELEHEALTH_SEND_SMS_BUTTON,
    Section: TrackingConstants.TARGETS.SEARCH_RESULTS,
});

export const trackProfileSendSmsClick = trackSendSmsClick({
    Component: TrackingConstants.TARGETS.TELEHEALTH_BOOKING_SIDEBAR,
    Element: TrackingConstants.TARGETS.TELEHEALTH_SEND_SMS_BUTTON,
    Section: TrackingConstants.TARGETS.TELEHEALTH_PROFILE,
});

export const trackModalClose = () => ({
    type: ActionTypes.TRACK_MODAL_CLOSE_BUTTON_CLICK,
    meta: {
        analytics: {
            category: 'Telehealth',
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Close Modal',
            data: {
                Component: TrackingConstants.TARGETS.TELEHEALTH_MODAL,
                Element: TrackingConstants.TARGETS.TELEHEALTH_MODAL_CLOSE,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Section: TrackingConstants.TARGETS.SEARCH_RESULTS,
            },
        },
    },
});

const trackPhoneNumberInput = ({ Component, Element, Section }) => () => ({
    type: ActionTypes.TRACK_PHONE_NUMBER_INPUT,
    meta: {
        analytics: {
            category: 'Telehealth',
            type: AnalyticsTypes.TrackEvent,
            action: 'Type Phone Number',
            data: {
                Component,
                Element,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.TYPE,
                Section,
            },
        },
    },
});

export const trackModalPhoneNumberInput = trackPhoneNumberInput({
    Component: TrackingConstants.TARGETS.TELEHEALTH_MODAL,
    Element: TrackingConstants.TARGETS.TELEHEALTH_PHONE_NUMBER_INPUT,
    Section: TrackingConstants.TARGETS.SEARCH_RESULTS,
});

export const trackProfilePhoneNumberInput = trackPhoneNumberInput({
    Component: TrackingConstants.TARGETS.TELEHEALTH_BOOKING_SIDEBAR,
    Element: TrackingConstants.TARGETS.TELEHEALTH_PHONE_NUMBER_INPUT,
    Section: TrackingConstants.TARGETS.TELEHEALTH_PROFILE,
});

const trackSendSmsSuccessView = ({ Component, Element, Section }) => () => ({
    type: ActionTypes.TRACK_SMS_SUCCESS_VIEW,
    meta: {
        analytics: {
            category: 'Telehealth',
            type: AnalyticsTypes.TrackEvent,
            action: 'View Branch Send SMS Success',
            data: {
                Component,
                Element,
                Initiator: TrackingConstants.EVENT_INITIATORS.SYSTEM,
                InteractionType: TrackingConstants.INTERACTION_TYPES.VIEW,
                Section,
            },
        },
    },
});

export const trackModalSendSmsSuccessView = trackSendSmsSuccessView({
    Component: TrackingConstants.TARGETS.TELEHEALTH_MODAL,
    Element: TrackingConstants.TARGETS.TELEHEALTH_SEND_SMS_SUCCESS,
    Section: TrackingConstants.TARGETS.SEARCH_RESULTS,
});

export const trackProfileSendSmsSuccessView = trackSendSmsSuccessView({
    Component: TrackingConstants.TARGETS.TELEHEALTH_BOOKING_SIDEBAR,
    Element: TrackingConstants.TARGETS.TELEHEALTH_SEND_SMS_SUCCESS,
    Section: TrackingConstants.TARGETS.TELEHEALTH_PROFILE,
});

const trackSendSmsFailureView = ({ Component, Element, Section }) => () => ({
    type: ActionTypes.TRACK_SMS_FAILURE_VIEW,
    meta: {
        analytics: {
            category: 'Telehealth',
            type: AnalyticsTypes.TrackEvent,
            action: 'View Branch Send SMS Failure',
            data: {
                Component,
                Element,
                Initiator: TrackingConstants.EVENT_INITIATORS.SYSTEM,
                InteractionType: TrackingConstants.INTERACTION_TYPES.VIEW,
                Section,
            },
        },
    },
});

export const trackModalSendSmsFailureView = trackSendSmsFailureView({
    Component: TrackingConstants.TARGETS.TELEHEALTH_MODAL,
    Element: TrackingConstants.TARGETS.TELEHEALTH_SEND_SMS_FAILURE,
    Section: TrackingConstants.TARGETS.SEARCH_RESULTS,
});

export const trackProfileSendSmsFailureView = trackSendSmsFailureView({
    Component: TrackingConstants.TARGETS.TELEHEALTH_BOOKING_SIDEBAR,
    Element: TrackingConstants.TARGETS.TELEHEALTH_SEND_SMS_FAILURE,
    Section: TrackingConstants.TARGETS.TELEHEALTH_PROFILE,
});

const trackProfileView = Element => () => ({
    type: ActionTypes.TRACK_PROFILE_VIEW,
    meta: {
        analytics: {
            category: 'Telehealth',
            type: AnalyticsTypes.TrackEvent,
            action: `View Telehealth Profile ${Element}`,
            data: {
                Component: TrackingConstants.TARGETS.TELEHEALTH_PROVIDER,
                Element,
                Initiator: TrackingConstants.EVENT_INITIATORS.SYSTEM,
                InteractionType: TrackingConstants.INTERACTION_TYPES.VIEW,
                Section: TrackingConstants.TARGETS.TELEHEALTH_PROFILE,
            },
        },
    },
});

export const trackProfileProviderOnlineView = trackProfileView(TrackingConstants.TARGETS.TELEHEALTH_ONLINE_INDICATOR);

export const trackProfileProviderOfflineView = trackProfileView(TrackingConstants.TARGETS.TELEHELATH_OFFLINE_INDICATOR);
